import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '@/hooks/useAuth';
import { useAuthStore } from '@/store/useAuthStore';
import { matchProfileRoute } from '@/components/CustomLink/CustomLink.helpers';
import { getLoginUrlWithReturn } from '@/utils/helpers';

export const AuthCheck = () => {
  const router = useRouter();
  const { asPath } = router;
  const { getBaseUser } = useAuth();

  useEffect(() => {
    getBaseUser();
  }, [asPath]);

  useEffect(() => {
    function handlePageShow(event: PageTransitionEvent) {
      if (!event.persisted) return;

      getBaseUser().then(() => {
        const { isAuthenticated } = useAuthStore.getState();

        if (isAuthenticated || !matchProfileRoute(router.asPath)) return;

        router.replace(getLoginUrlWithReturn(router.asPath));
      });
    }

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [getBaseUser, router]);

  return null;
};
